const constrains = {
  identification: {
    presence: {
      message: 'Ingresar una identificación',
      allowEmpty: false,
    },
  },
  name: {
    presence: {
      message: 'Ingresar el nombre',
      allowEmpty: false,
    },
  },
  lastname: {
    presence: {
      message: 'Ingresar el apellido',
      allowEmpty: false,
    },
  },
  description: {
    presence: {
      message: 'Ingresar la descripción',
      allowEmpty: false,
    },
  },
  amount: {
    presence: {
      message: 'Ingresar la cantidad',
      allowEmpty: false,
    },
  },
  email: {
    presence: {
      message: 'Ingresar un correo',
      allowEmpty: false,
    },
    email: {
      message: 'Formato incorrecto de correo.',
    },
  },
  emails: {
    presence: {
      message: 'Ingresar un correo',
      allowEmpty: false,
    },
    email: {
      message: 'Formato incorrecto de correo.',
    },
  },
  username: {
    presence: {
      message: 'Ingresar el username',
      allowEmpty: false,
    },
  },
  password: {
    presence: {
      message: 'Ingresar la contraseña',
      allowEmpty: false,
    },
    length: {
      minimum: 5,
      message: 'La contraseña debe tener mínimo 5 carácteres.',
    },
  },
  phone: {
    presence: {
      message: 'Ingresar un teléfono',
      allowEmpty: false,
    },
    length: {
      minimum: 10,
      maximum: 10,
      message: 'El teléfono debe tener 10 dígitos',
    },
  },
  date: {
    presence: {
      message: 'Ingrese una fecha',
      allowEmpty: false,
    },
  },
  startDate: {
    presence: {
      message: 'Ingrese una fecha de inicio',
      allowEmpty: false,
    },
  },
  endDate: {
    presence: {
      message: 'Ingrese una fecha de finalización',
      allowEmpty: false,
    },
  },
  observationsRequest: {
    presence: {
      message: 'Ingrese las observaciones',
      allowEmpty: false,
    },
  },
  observations: {
    presence: {
      message: 'Ingrese las observaciones',
      allowEmpty: false,
    },
  },
  descriptionData: {
    presence: {
      message: 'Ingrese el nombre del departamento',
      allowEmpty: false,
    },
  },
  employeeCode: {
    presence: {
      message: 'Seleccione un empleado',
      allowEmpty: false,
    },
  },
  employee: {
    presence: {
      message: 'Seleccione un empleado',
      allowEmpty: false,
    },
  },
  periodVacation: {
    presence: {
      message: 'Seleccione un periodo',
      allowEmpty: false,
    },
  },
  boos: {
    presence: {
      message: 'Seleccione un jefe',
      allowEmpty: false,
    },
  },
  reemplace: {
    presence: {
      message: 'Seleccione un reemplazo',
      allowEmpty: false,
    },
  },
  typeRequest: {
    presence: {
      message: 'Seleccione un tipo de solicitud',
      allowEmpty: false,
    },
  },
  idDepartment: {
    presence: {
      message: 'Seleccione una dependencia',
      allowEmpty: false,
    },
  },
  idTypeEmployee: {
    presence: {
      message: 'Seleccione un tipo de empleado',
      allowEmpty: false,
    },
  },
  startDateEmployeeDep: {
    presence: {
      message: 'Seleccione una fecha válida',
      allowEmpty: false,
    },
  },
  file: {
    presence: {
      message: 'Seleccione un archivo',
      allowEmpty: false,
    },
  },
};

export type ConstrainNames = keyof typeof constrains;

const getConstrains = (fields: ConstrainNames[]): {} => {
  return fields.reduce(function (result: {[key: string]: {}}, prop: ConstrainNames) {
    result[prop] = constrains[prop];
    return result;
  }, {});
};

export default getConstrains;
